import { render, staticRenderFns } from "./SliceProgrammeThumbsSmall.vue?vue&type=template&id=453650ee&lang=pug&"
import script from "./SliceProgrammeThumbsSmall.vue?vue&type=script&lang=js&"
export * from "./SliceProgrammeThumbsSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports